module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.efa76f8.ttf";